import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS_COST_CENTERS } from '../permissions'

// eslint-disable-next-line react/prefer-stateless-function
class CompaniesCostCentersListRow extends Component {
    handleClick = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onClick && this.props.onClick(this.props.item)
    }

    handleDelete = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onDelete && this.props.onDelete(this.props.item)
    }

    render() {
        const address = this.props.item

        return (
            <tr onClick={this.handleClick} className="row-selectable">
                <PermissionsCheck hasAny={[PERMS_COST_CENTERS.UPDATE, PERMS_COST_CENTERS.DELETE]}>
                    <td className="w-60 table-buttons">
                        <PermissionsCheck has={[PERMS_COST_CENTERS.UPDATE]}>
                            <button className="far fa-pencil text-gray m-r-xxs" />
                        </PermissionsCheck>
                        <PermissionsCheck has={[PERMS_COST_CENTERS.DELETE]}>
                            <button onClick={this.handleDelete} className="far fa-trash text-gray" />
                        </PermissionsCheck>
                    </td>
                </PermissionsCheck>
                <td className="w-100">{address.code}</td>
                <td className="w-max wm-200">
                    <strong>{address.name}</strong>
                </td>
            </tr>
        )
    }
}

export default injectIntl(CompaniesCostCentersListRow)
